import styled from 'styled-components'

export const ActionSpace = styled('div', {
    shouldForwardProp: (prop) => !['direction', 'justify', 'block'].includes(prop),
})(({ direction = 'vertical', justify = 'space-between', block = false }) => `
    display: flex;
    flex-direction: ${direction === 'vertical' ? 'column' : 'row'};
    flex-grow: ${block ? 1 : 0};
    flex-wrap: wrap;
    gap: 6px;
    justify-content: ${justify};
    ${direction === 'horizontal' ? 'align-items: center;' : ''}

    && {
        svg {
            margin-left: 0;
        }
    }
`)

export const UpdatedAt = styled.abbr`
  cursor: help;
`;